import { Container, Divider, Paper, Stack } from '@mui/material';
import { getRouterPathToContentIndex } from '../../utilities/Links';
import { Category } from '../../types/types';
import { getPrimaryCategories } from '../../utilities/Categories';
import SecondaryBarLink from './SecondaryBarLink';

export default function CategoryHeader() {
  const primaryCategoriesFormatted: Category[] = getPrimaryCategories().map(
    (category) => {
      return {
        name: category,
        path: getRouterPathToContentIndex(category),
      };
    },
  );

  return (
    <Paper elevation={0}>
      <Container maxWidth='lg' disableGutters sx={{ px: 2 }}>
        <Stack
          direction='row'
          sx={{
            justifyContent: 'space-between',
            paddingY: 0.25,
          }}
        >
          {primaryCategoriesFormatted.map((category) => {
            return (
              <SecondaryBarLink
                key={'frontpage-category-link-' + category.name}
                to={category.path}
              >
                {category.name}
              </SecondaryBarLink>
            );
          })}
        </Stack>
      </Container>
      <Divider />
    </Paper>
  );
}
